import React, { useState } from 'react'
import {Form, Button} from 'react-bootstrap'
import axios from 'axios';
// import { useNavigate } from "react-router-dom";
import _forEach from 'lodash/forEach'

function LoginForms() {
  // let navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");  
  
  const onSubmit = async (event) => {
    event.preventDefault();

    await axios.post(process.env.REACT_APP_DRUPAL_PATH+'/mp_authentication_api/user/login', {
      username: username, 
      password: password
    },
    { 
      headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    })
    .then(function (response) {
      let role = null;
      _forEach(response.data.user.roles, function(value) {
        if(value !== 'authenticated user'){
          role = value;
        }
      });
      let user = {
        uid:response.data.user.uid,
        role:role
      }
      let usercreds = { 
        sessid: response.data.sessid, 
        session_name:response.data.session_name, 
        token:response.data.token, 
        user:user 
      };
      localStorage.setItem("authenticated", JSON.stringify(usercreds));      
      localStorage.setItem("isauthenticated", true);
      // navigate("", { replace: true });
      window.location.reload(true);
    })
    .catch(function (error) {
      console.log(error);
    });

    
  };
  
  return (
    <div className="main-login-form">
        <div className="logo-login text-center">
          <div className="login-logo">
            <img alt="manpower-logo" src={process.env.PUBLIC_URL + '/assets/images/manpower-login-logo.png'} />
          </div>          
        </div>
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Username</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="Username" 
              value={username} 
              required 
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control 
              type="password" 
              placeholder="Password" 
              value={password} 
              required 
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <div className="text-center">
            <Button variant="primary" type="submit">
              SIGN IN
            </Button>
          </div>                
        </Form>
      </div>
  )
}

export default LoginForms